import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { REMOVE_FEATURE_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const RemoveFeatureService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_FEATURE_RESOURCE,
      method: 'delete',
      request: (appId, installationId, featureId, callback, appInstallation = {}, resource, t) => ({
        url: apiRoutes.featureDetail(appId, installationId, featureId),
        meta: {
          featureId,
          callback,
          setOther: {
            resource,
            listPath: 'appInstallationFeatures',
            value: (appInstallation?.appInstallationFeatures || []).filter(f => f.id !== featureId),
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeFeatureFailed'),
            onSuccessMessage: t('removeFeatureSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveFeatureService;
